<template>
  <hsc-window-style-white>
    <hsc-window
      :title="custno"
      :closeButton="true"
      :resizable="true"
      :isScrollable="true"
      :isOpen.sync="custno"
      positionHint="center"
      :minWidth="500"
      :maxWidth="1750"
      :minHeight="500"
      :maxHeight="800"
    >
      <b-container class="client-overlay-container" fluid>
        <b-row>
          <b-tabs content-class="mt-3" fill>
            <b-tab title="Overview" active>
              <b-row>
                <b-col>
                  <h4>General Information</h4>
                  <table class="table-striped table-hover table-small col-6">
                    <tbody>
                    <tr>
                      <td><b>Client Code:</b></td>
                      <td>{{ custno }}</td>
                    </tr>
                    <tr>
                      <td><b>Client Name:</b></td>
                      <td>{{ client.company }}</td>
                    </tr>
                    <tr>
                      <td><b>Address:</b></td>
                      <td>
                        <client-address
                          v-bind:address1="client.address1"
                          v-bind:address2="client.address2"
                          v-bind:city="client.city"
                          v-bind:state="client.state"
                          v-bind:zip="client.zip"
                          v-bind:country="client.country"
                        ></client-address>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Phone:</b></td>
                      <td>
                        <phone-number v-bind:phone="client.phone"></phone-number>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Fax:</b></td>
                      <td>{{ client.fax }}</td>
                    </tr>
                    <tr>
                      <td><b>URL</b></td>
                      <td>{{ client.url }}</td>
                    </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col>
                  <h4>Company Information</h4>
                  <table class="table-striped table-hover table-small col-6">
                    <tbody>
                    <tr>
                      <td><b>Priority Client:</b></td>
                      <td>{{ vicValue }}</td>
                    </tr>
                    <tr>
                      <td><b>Transactional Buyer:</b></td>
                      <td>
                        <b-select v-model="transBuyerValue" v-bind:options="transBuyerOptions" size="sm">
                        </b-select>
                      </td>
                    </tr>
                    <tr>
                      <td><b>SIC Code(s):</b></td>
                      <td>{{ [client.sic, client.sic2, client.sic3].join(' ') }}</td>
                    </tr>
                    <tr>
                      <td><b>NAICS Code(s):</b></td>
                      <td>{{ [client.naics, client.naics2, client.naics3].join(' ') }}</td>
                    </tr>
                    <tr>
                      <td><b>OEM/MRO/Resale:</b></td>
                      <td>
                        <b-select v-model="omrValue" v-bind:options="omrOptions" size="sm"></b-select>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Industry Type:</b></td>
                      <td>TODO</td>
                    </tr>
                    <tr>
                      <td><b>Source:</b></td>
                      <td>{{ client.source }}</td>
                    </tr>
                    <tr>
                      <td><b>Add Date:</b></td>
                      <td>{{ client.enteredOn }}</td>
                    </tr>
                    <tr>
                      <td><b>Office:</b></td>
                      <td>{{ client.terr }}</td>
                    </tr>
                    <tr>
                      <td><b>Salesperson:</b></td>
                      <td>{{ client.salesmn }}</td>
                    </tr>
                    <tr>
                      <td><b>Invoice Type:</b></td>
                      <td>{{ client.code }}</td>
                    </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col>
                  <h4>Client Account</h4>
                  <table class="table-striped table-hover table-small col-6">
                    <tbody>
                    <tr>
                      <td><b>Priority AR Client:</b></td>
                      <td>{{ client.vic }}</td>
                    </tr>
                    <tr>
                      <td><b>Tax Rate:</b></td>
                      <td>{{ client.sic }}</td>
                    </tr>
                    <tr>
                      <td><b>National Account:</b></td>
                      <td>{{ client.omr }}</td>
                    </tr>
                    <tr>
                      <td><b>Average Days Between Orders:</b></td>
                      <td>{{ averageDaysBetweenOrders.toFixed(2) }}</td>
                    </tr>
                    <tr>
                      <td><b>Projected Next Order Date:</b></td>
                      <td>{{ projectedNextOrderDate }}</td>
                    </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col>
                  <h4>Client Notes</h4>
                  <b-row v-for="note in client.notes" v-bind:key="note">
                    <div>{{ note }}</div>
                  </b-row>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col>
                  <h4>Historical Margins</h4>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Activity"></b-tab>
            <b-tab title="Addresses"></b-tab>
            <b-tab title="Purchased"></b-tab>
            <b-tab title="Open Orders"></b-tab>
            <b-tab title="Open AR"></b-tab>
            <b-tab title="Shipments"></b-tab>
            <b-tab title="Routing/Packaging"></b-tab>
            <b-tab title="SA & BO"></b-tab>
            <b-tab title="Quotes"></b-tab>
            <b-tab title="Contacts"></b-tab>
            <b-tab title="Payments"></b-tab>
            <b-tab title="Map"></b-tab>
            <b-tab title="Part Numbers"></b-tab>
            <b-tab title="Client Items"></b-tab>
          </b-tabs>
        </b-row>
      </b-container>
    </hsc-window>
  </hsc-window-style-white>
</template>

<script>

import Address from '../../contact_info/Address'
import store from '@/store'
import PhoneNumber from '../../contact_info/PhoneNumber'

export default {
  name: 'ClientOverlay',
  props: ['custno'],
  components: {
    'client-address': Address,
    'phone-number': PhoneNumber
  },
  data () {
    return {
      vicValue: this.vic ? 'YES' : 'NO',
      transBuyerValue: this.transBuyer ? 'YES' : 'NO',
      transBuyerOptions: [
        {value: 'YES', text: 'YES'},
        {value: 'NO', text: 'NO'}
      ],
      omrValue: this.omr,
      omrOptions: [
        {value: '', text: ''},
        {value: 'OEM', text: 'OEM'},
        {value: 'MRO', text: 'MRO'},
        {value: 'Resale', text: 'Resale'}
      ]
    }
  },
  computed: {
    client () {
      return store.state.clients.client
    },
    vic () {
      return store.state.clients.client.vic
    },
    transBuyer () {
      return store.state.clients.transBuyer
    },
    omr () {
      return store.state.clients.omr
    },
    averageDaysBetweenOrders () {
      return store.state.clients.daysBetweenOrders
    },
    projectedNextOrderDate () {
      return store.state.clients.projectedNextOrderDate
    }
  },
  beforeMount () {
    store.dispatch('clients/fetchClient', this.custno.trim())
    store.dispatch('clients/fetchAverageDaysBetweenOrders', this.custno.trim())
    store.dispatch('clients/fetchHistoricalMargins', this.custno.trim())
  }
}
</script>

<style>
.client-overlay-container{
  background-color: white;
}
</style>
